import faker from 'faker';
import { sample } from 'lodash';
// utils
import { mockImgAvatar } from '../utils/mockImages';

// ----------------------------------------------------------------------

const users = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  avatarUrl: mockImgAvatar(index + 1),
  name: faker.name.findName(),
  diagnostico: sample(['Cervicalgia', 'Lombalgia']),
  satisfacao: sample(['Satisfeito', 'Insatisfeito']),
  atividade: sample([
    '10 sessões',
    '20 sessões',
    '30 sessões',
    '40 sessões',
    '50 sessões',
    '60 sessões',
    '70 sessões',
    '3 sessões',
    '920 sessões',
    '2 sessões',
    '540 sessões',
  ])
}));

export default users;
